export default __webpack_public_path__ + "1ce2b18d8487624dc097c7d3aced080f.png";